import { t } from '../config/translations';

export const returnReasonOptions = [
  {
    get label() {
      return t('reason.articleTooBig');
    },
    value: '009',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.articleTooSmall');
    },
    value: '010',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.colorNotSuitable');
    },
    value: '012',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.resignation');
    },
    value: '001',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.qualityDefect');
    },
    value: '003',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.duplicate');
    },
    value: '013',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.bragardError');
    },
    value: '004',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.clientError');
    },
    value: '005',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.embroideryError');
    },
    value: '007',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.sample');
    },
    value: '008',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.modelNotSuitable');
    },
    value: '011',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.deliveryProblem');
    },
    value: '002',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.commercialAgreement');
    },
    value: '006',
    color: 'blue',
  },
];

export const returnECSreasons = [
  {
    get label() {
      return t('reason.articleTooBig');
    },
    value: '009',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.articleTooSmall');
    },
    value: '010',
    color: 'blue',
  },
];

export const returnERMreasons = [
  {
    get label() {
      return t('reason.resignation');
    },
    value: '001',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.sample');
    },
    value: '008',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.articleTooBig');
    },
    value: '009',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.articleTooSmall');
    },
    value: '010',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.modelNotSuitable');
    },
    value: '011',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.colorNotSuitable');
    },
    value: '012',
    color: 'blue',
  },
  {
    get label() {
      return t('reason.duplicate');
    },
    value: '013',
    color: 'blue',
  },
];
